import React from 'react';
import { Space } from 'antd';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import CheckDetailButtonsWithModal from './CheckDetailButtonsWithModal';
import UpdateProcessButtonWithModal from './UpdateProcessButtonWithModal';
import CancelCarButton from './CancelCarButton';
import type { ColumnsType } from 'antd/es/table';
import type { NeedCareDataType, ReservationDataType } from '../types';

dayjs.extend(advancedFormat);

const reservationTimeSorter = (
  a: ReservationDataType,
  b: ReservationDataType
) => {
  if (
    Number(dayjs(a.reservationTime).format('x')) -
      Number(dayjs(b.reservationTime).format('x')) >
    0
  ) {
    return 1;
  } else if (
    Number(dayjs(a.reservationTime).format('x')) -
      Number(dayjs(b.reservationTime).format('x')) <
    0
  ) {
    return -1;
  } else {
    return 0;
  }
};

const arrivalTimeSorter = (a: ReservationDataType, b: ReservationDataType) => {
  if (
    Number(dayjs(a.estimatedArrivalTime).format('x')) -
      Number(dayjs(b.estimatedArrivalTime).format('x')) >
    0
  ) {
    return 1;
  } else if (
    Number(dayjs(a.estimatedArrivalTime).format('x')) -
      Number(dayjs(b.estimatedArrivalTime).format('x')) <
    0
  ) {
    return -1;
  } else {
    return 0;
  }
};

export const needCareReservationColumns: ColumnsType<NeedCareDataType> = [
  {
    title: '預約關懷時間(年/月/日)',
    dataIndex: 'estimatedArrivalTime',
    sorter: {
      compare: arrivalTimeSorter,
    },
  },
  { title: '聯繫電話', dataIndex: 'phoneNumber' },
  { title: '戶號', dataIndex: 'householdNumber' },
  { title: '姓名', dataIndex: 'name' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    render: (texts: string[], record) => {
      return (
        <Space>
          <CheckDetailButtonsWithModal
            title="待關懷下車住戶"
            reservationId={record.key}
          />
          <UpdateProcessButtonWithModal reservation={record} />
        </Space>
      );
    },
  },
];

export const reservationColumns: ColumnsType<ReservationDataType> = [
  {
    title: '預約乘車時間(年/月/日)',
    dataIndex: 'reservationTime',
    sorter: {
      compare: reservationTimeSorter,
    },
  },
  {
    title: '預計下車時間(年/月/日)',
    dataIndex: 'estimatedArrivalTime',
    sorter: {
      compare: arrivalTimeSorter,
    },
  },
  { title: '狀態', dataIndex: 'status' },
  { title: '戶號', dataIndex: 'householdNumber' },
  { title: '住戶', dataIndex: 'name' },
  { title: '車隊', dataIndex: 'fleetName' },
  { title: '車牌號碼', dataIndex: 'carNumber' },
  { title: '司機', dataIndex: 'driverName' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    render: (texts: string[], record) => {
      return (
        <Space>
          <CheckDetailButtonsWithModal
            title={
              record.status === '已預約' ||
              record.status === '已安排' ||
              record.status === '車輛已抵達'
                ? '今日未上車住戶'
                : '今日已上車住戶'
            }
            reservationId={record.key}
          />
          <UpdateProcessButtonWithModal reservation={record} />
          {record.status === '已預約' ||
          record.status === '已安排' ||
          record.status === '車輛已抵達' ? (
            <CancelCarButton reservation={record} />
          ) : null}
        </Space>
      );
    },
  },
];
